import { ApplicationFormStatusEnum, InitialState } from "../../Models";
import { action, computed, observable } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import { DashboardModel } from "../../Models/Domain/Dashboard/DashboardModel";
import React, { useState, useContext } from "react";
import { StoresInstance } from "../../Stores";
const domainStores = StoresInstance.Domain;

// App
import { AppUrls } from "AppUrls";
import { ApplicationFormDTO } from "Globals/Models/DTO/ApplicationFormDTO";
import { UpsertApplicationFormDTO } from "Globals/Models/DTO/Upsert/UpsertApplicationFormDTO";
import { DashboardModelDTO } from "Globals/Models/DTO/DashboardModelDTO";
import { computedFn } from "mobx-utils";
import DashboardApplicationViewModel from "Globals/ViewModels/Dashboard/DashboardApplicationViewModel";

export default class DashboardViewModel extends ViewModelBase<DashboardModel> {
    @observable
    private applicationFormViewModel: DashboardApplicationViewModel[] = [];

    @computed
    public get applications(): DashboardApplicationViewModel[] {
        return this.applicationFormViewModel.filter((a) => a.model.isDeleted === false);
    }
    @computed
    public get sortedApplications(): DashboardApplicationViewModel[] {
        return this.applications
            .slice()
            .sort((a, b) => (b.model.lastSavedDate ? new Date(b.model.lastSavedDate).getTime() : 0) - (a.model.lastSavedDate ? new Date(a.model.lastSavedDate).getTime() : 0));
    }
    @computed
    public get submittedApplications(): DashboardApplicationViewModel[] {
        return this.sortedApplications.filter((a) => a.model.submittedDate !== null);
    }
    @computed
    public get notSubmittedApplications(): DashboardApplicationViewModel[] {
        return this.sortedApplications.filter((a) => a.model.submittedDate === null);
    }
    constructor() {
        super(new DashboardModel());
        this.loadDashboardAsync();
    }

    @action
    private createViewModels(): void {
        for (const application of this.model.applicationModels) {
            this.applicationFormViewModel.push(new DashboardApplicationViewModel(application));
        }
    }

    @action
    public async loadDashboardAsync(): Promise<ApiResult<DashboardModelDTO>> {
        this.setIsLoading(true);
        const apiResult = await this.Get<DashboardModelDTO>(AppUrls.Server.Dashboard);
        if (apiResult.wasSuccessful) {
            this.applicationFormViewModel.length = 0;
            this.model.fromDto(apiResult.payload);
            this.createViewModels();
        }
        this.setIsLoading(false);
        return apiResult;
    }

    @action
    public createNewApplication = async (): Promise<void> => {
        this.setIsLoading(true);
        const status = domainStores.ApplicationFormStatusStore.getApplicationFormStatus();
        const defaultStatus = status.find((s) => s.isDefaultStatus);
        try {
            const emptyDTO: ApplicationFormDTO = {
                id: "",
                createdByUserId: "",
                statusId: defaultStatus ? defaultStatus.id : "",
                lastSavedDate: new Date(),
                createdDate: null,
                submittedDate: null,
                isSubmitted: false,
                isCompleted: false,
                rejectReasonId: null,
                rejectReasonDetail: null,
                isDeleted: false,
                requestedSupportingInfo: false,
            };
            const emptyUpsertDTO: UpsertApplicationFormDTO = {
                applicationForm: emptyDTO,
            };
            const apiResult = await this.Post<ApplicationFormDTO>(AppUrls.Server.ApplicationForm.Upsert.Application, emptyUpsertDTO);
            if (apiResult.wasSuccessful) {
                let applicationId = apiResult.payload.id ? apiResult.payload.id : "";
                this.history.push(AppUrls.Client.Application.replace(":applicationId?", applicationId));
            } else {
                console.error(apiResult.errors);
            }
        } catch (exception) {
            // Set server validation error messages.
        } finally {
            // Finally
            this.setIsLoading(false);
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<DashboardModel>, value: any): Promise<boolean> {
        // let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        // this.setError(fieldName, errorMessage);
        // this.setValid(fieldName, isValid);

        // return isValid;
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
